import { FC, memo } from "react"

import Skeleton from "./base"
import GraphSkeletonImage from "../../../assets/images/graph-skeleton.png"

interface GraphProps {
  className?: string
}

const Graph: FC<GraphProps> = ({ className = "" }) => {
  return (
    <div
      className={`bg-white flex-1 content-center overflow-hidden ${className}`}
    >
      <Skeleton className="h-full">
        <div className="flex flex-col justify-between items-between h-full">
          <div className="flex w-full h-32 mb-2">
            <div className="flex flex-col w-1/3">
              <div className="w-3/4 h-3 bg-gray-200 rounded-full mb-2.5"></div>
              <div className="w-3/5 h-5 bg-gray-100 rounded-full"></div>
            </div>
            <div className="flex flex-col w-1/3">
              <div className="w-3/4 h-3 bg-gray-200 rounded-full mb-2.5"></div>
              <div className="w-3/5 h-5 bg-gray-100 rounded-full"></div>
            </div>
          </div>
          <div className="w-full flex-1 flex items-end justify-center">
            <img
              className="w-full h-16"
              src={GraphSkeletonImage}
              alt="graph-skeleton"
            />
          </div>
          <div className="w-full h-[3px] bg-gray-100 mt-11 mb-[22px]"></div>
        </div>
      </Skeleton>
    </div>
  )
}

export default memo(Graph)
